// extracted by mini-css-extract-plugin
export default {"wrapper_input":"styles_wrapper_input__LS3xB","input":"styles_input__BWi-9","buttonDeleteSearch":"styles_buttonDeleteSearch__N4hy4"};